import { FC, useContext } from 'react';
import { SnackbarKey, useSnackbar } from 'notistack';
import { Stack } from '@mui/material';
import {
  COMMON_STRING,
  ERROR_STRING,
  SUCCESS_STRING,
} from '@/constants/dictionary';
import { ActionDialogProps } from '@/components/ActionsDialog/types';
import { ScoringContext } from '@/contexts/scoring/context';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { generateSubTitleDialog } from '@/utils/dialogSubTitle/generateSubTitleDialog';
import { EditAction } from '../EditAction/EditAction';
import { SnackbarGoToTopAction } from '../SnackbarActions/SnackbarGoToTopAction';
import { SnackbarCloseAction } from '../SnackbarActions/SnackbarCloseAction';
import { MTDialog } from '../common/MTDialog';

export const EditActionDialog: FC<ActionDialogProps> = ({
  action,
  onClose,
  listRef,
  isScrollTopVisible,
}) => {
  const {
    state: { actionTypesCurrentSport },
  } = useContext(ScoringContext);

  const { enqueueSnackbar } = useSnackbar();
  const editActionDialogSnackbarAction = (snackbarId: SnackbarKey) =>
    listRef && isScrollTopVisible ? (
      <>
        <SnackbarGoToTopAction snackbarId={snackbarId} listRef={listRef} />
        <SnackbarCloseAction snackbarId={snackbarId} />
      </>
    ) : (
      <SnackbarCloseAction snackbarId={snackbarId} />
    );

  const onSuccess = () => {
    enqueueSnackbar(SUCCESS_STRING.ACTION_SUCCESSFULLY_EDITED, {
      variant: 'success',
      action: editActionDialogSnackbarAction,
    });
    onClose();
  };
  const onError = (error?: Error) => {
    enqueueSnackbar(error?.message ?? ERROR_STRING.FAILED_UPDATE_ACTION, {
      variant: 'error',
    });
    onClose();
  };

  return (
    <MTDialog
      aria-label={ARIA_LABEL.EDIT_ACTION_DIALOG}
      maxWidth='md'
      fullWidth
      open={true}
      onClose={onClose}
      title={COMMON_STRING.EDIT_ACTION}
    >
      <Stack gap={2} flex='1 0 0'>
        {generateSubTitleDialog({ action, actionTypesCurrentSport })}
        <EditAction
          action={action}
          onCancel={onClose}
          onError={onError}
          onSuccess={onSuccess}
        />
      </Stack>
    </MTDialog>
  );
};
